import { useState, useEffect } from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import { Typography } from '@mui/material';
import { getPortalUrl } from '../../../services/stripe.service';
import {
	COLOR_DRAWER_ICON_MANAGE_ACCOUNT,
	COLOR_DRAWER_ITEM_HOVER,
	COLOR_DRAWER_ICON_LOADING,
	COLOR_DRAWER_ITEM_TEXT,
} from '../../../styles/tokens';

export const ManageSubscription = (props) => {
	const { callBack } = props;
	const [url, setURL] = useState(null);

	useEffect(() => {
		getPortalUrl().then(setURL);
	}, []);

	const onManageSubscriptionClick = async () => {
		callBack();
		window.location.assign(url);
	};

	const itemSx = { '&:hover': { backgroundColor: COLOR_DRAWER_ITEM_HOVER } };
	const iconSx = {
		color: COLOR_DRAWER_ICON_MANAGE_ACCOUNT,
		minWidth: '40px',
	};
	const textProps = { variant: 'h5', sx: { color: COLOR_DRAWER_ITEM_TEXT } };

	if (url === null) {
		return (
			<ListItem key={'Subscription'} disablePadding>
				<ListItemButton sx={itemSx}>
					<ListItemIcon sx={iconSx}>
						<CircularProgress
							size={20}
							sx={{ color: COLOR_DRAWER_ICON_LOADING }}
						/>
					</ListItemIcon>
					<ListItemText
						primary={'Manage account'}
						primaryTypographyProps={textProps}
					/>
				</ListItemButton>
			</ListItem>
		);
	} else if (url === undefined) {
		return null;
	} else if (url === 'error') {
		return (
			<Tooltip
				title={
					<Typography variant="h5">
						Continue pattern creation to purchase
					</Typography>
				}
			>
				<ListItem key={'Subscription'} disablePadding>
					<ListItemButton disabled onClick={() => {}}>
						<ListItemIcon sx={iconSx}>
							<ManageAccountsIcon />
						</ListItemIcon>
						<ListItemText
							primary={'Manage account'}
							primaryTypographyProps={textProps}
						/>
					</ListItemButton>
				</ListItem>
			</Tooltip>
		);
	} else {
		return (
			<ListItem key={'Subscription'} disablePadding>
				<ListItemButton
					onClick={() => {
						onManageSubscriptionClick();
					}}
					sx={itemSx}
				>
					<ListItemIcon sx={iconSx}>
						<ManageAccountsIcon />
					</ListItemIcon>
					<ListItemText
						primary={'Manage account'}
						primaryTypographyProps={textProps}
					/>
				</ListItemButton>
			</ListItem>
		);
	}
};
